export const columns = [
    {
        key: 'index',
        title: '#',
        formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
    },
    {
        key: 'name',
        title: 'Document Name',
        formatter: (_: any, __: any, rowIndex: number) => `Document ${rowIndex + 1}`,
    },
    {
        key: 'action',
        title: 'Action',
        isAction: true,
    },
];
